import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MbNavigationService, NavigationNode } from '../../mb-navigation.service'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { SelectedFilter } from '../mb-category-navigation.module'
import { NavigationFilterClickEvent } from '../../../components/types'
import { MbConstants } from '../../../../shared/mb-constants'
import { map } from 'rxjs/operators'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-category-navigation-first-level',
  templateUrl: './mb-category-navigation-first-level.component.html',
  styleUrls: ['./mb-category-navigation-first-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationFirstLevelComponent {

  @Output() filterClick = new EventEmitter<NavigationFilterClickEvent>()
  @Output() triggerClose = new EventEmitter<Event>()

  @Input() set selectedFilter (selectedFilter: SelectedFilter | undefined | null) {
    this.selectedFilter$.next(selectedFilter)
  }

  @Input() set selectedCategory (selectedCategory: NavigationNode | undefined | null) {
    this.selectedCategory$.next(selectedCategory)
  }

  @Input() set activeFilter (activeFilter: NavigationNode | undefined | null) {
    this.activeFilter$.next(activeFilter)
  }

  selectedFilter$ = new BehaviorSubject<SelectedFilter | undefined | null>(undefined)
  selectedCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  activeFilter$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)

  navigation$ = this.navigationService.navigation$

  state$ = combineLatest([this.navigation$, this.selectedFilter$, this.selectedCategory$, this.activeFilter$]).pipe(
    map(([navigation, selectedFilter, selectedCategory, activeFilter]) => ({
      navigation,
      selectedFilter,
      selectedCategory,
      activeFilter
    } as MbCategoryNavigationFirstLevelState)))

  constructor (private navigationService: MbNavigationService) {
  }

  readonly products = MbConstants.PRODUCTS
  readonly applications = MbConstants.APPLICATIONS
  readonly orange = MbConstants.CORPORATE_ORANGE
  protected readonly cmsLinkType = CmsLinkType
}

export interface MbCategoryNavigationFirstLevelState {
  navigation: NavigationNode[];
  selectedFilter: SelectedFilter | undefined | null;
  selectedCategory: NavigationNode | undefined | null;
  activeFilter: NavigationNode | undefined | null;
}
